import React from 'react'
import { NpcChatMessageInput } from './components/NpcChatMessageInput/NpcChatMessageInput'
import { IGame } from '../../../../../../../api/types/game'
import { ICharacter } from '../../../../../../../api/types/character'
import { FormControl, MenuItem, Paper, Select, Theme, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { useChatEntryColorStyles } from '../../../../Chat/components/ChatMessageEntry/ChatEntryColors'
import { useStickyState } from '../../../../../../../hooks/useStickyState'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0.5),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
    controls: {
      display: 'flex',
    },
    inputContainer: {
      flexGrow: 1,
    },
  })
)

interface Props {
  game: IGame
  character: ICharacter
  showChatTab?: () => void
}

export const NpcSayPanel: React.FC<Props> = ({ game, character, showChatTab }) => {
  const classes = useStyles()
  const classesColors = useChatEntryColorStyles()

  const [color, setColor] = useStickyState({}, 'npcSayColors')
  const updateColorValue = (val: string) => {
    const newVal = { ...color }
    newVal[character.id] = val
    return newVal
  }

  const messageColorToClass = {
    red: classesColors.msgColorRed,
    dw: classesColors.msgColorDwrf,
    gn: classesColors.msgColorGnom,
    sh: classesColors.msgColorShap,
    mo: classesColors.msgColorMorh,
    hu: classesColors.msgColorHum,
    el: classesColors.msgColorElf,
    or: classesColors.msgColorOrc,
    silver: classesColors.msgColorSilver,
    gold: classesColors.msgColorGold,
  }

  return (
    <Paper className={classes.root}>
      <Typography color="text.secondary" variant="caption" display="block" gutterBottom>
        Powiedz jako <strong>{character.name}</strong>:
      </Typography>
      <div className={classes.controls}>
        <FormControl>
          <Select
            // @ts-ignore
            className={messageColorToClass[color[character.id]]}
            variant="standard"
            value={color[character.id] || ''}
            onChange={e => setColor(updateColorValue(e.target.value))}
            label="Kolor"
          >
            <MenuItem value="">
              <em>Domyślny</em>
            </MenuItem>
            {['dw', 'gn', 'sh', 'mo', 'hu', 'el', 'or', 'gold', 'silver', 'red'].map(c => (
              // @ts-ignore
              <MenuItem key={c} className={messageColorToClass[c]} value={c}>
                ◆
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className={classes.inputContainer}>
          <NpcChatMessageInput
            game={game}
            npcName={character.name}
            color={color[character.id]}
            showChatTab={showChatTab}
          />
        </div>
      </div>
    </Paper>
  )
}
